<template>
  <div>
    <vxe-table
        class="table-style"
        highlight-hover-row
        show-footer
        stripe
        align="center"
        border="none"
        auto-resize
        :data="tableData"
        max-height="540"
        :loading="loading"
    >
      <vxe-table-column field="id" title="序号" width="100">
        <template slot-scope="{ row }">
          <span>{{ row.id }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="fileName" title="文件名称">
        <template slot-scope="{ row }">
          <span>{{ row.fileName }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="createUser" title="导入时间">
        <template slot-scope="{ row }">
          <span>{{ row.createTime | timeFormatDate}}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="createUser" title="操作人"></vxe-table-column>
      <vxe-table-column title="操作" v-if="isHavePermission('bankLog:deleteImport')">
        <template slot-scope="{ row }">
          <span style="color: #2d8cf0; cursor: pointer; margin-right: 10px" @click="remove(row)">删除</span>
        </template>
      </vxe-table-column>
    </vxe-table>
  </div>
</template>
<script>
  import $api from "@/apiProvider";
  import {hideLoading, showLoading} from "@/utils/util";
  import getAuthOrization from "@/mixin/getAuthOrization";

  export default {
    mixins: [getAuthOrization],
    data() {
      return {
        tableData: [],
        linkAccountModal: false,
        loading: false,
      }
    },
    mounted() {
      this.bankAccountImportLog();
    },
    methods: {
      async bankAccountImportLog() {
        this.loading = true;
        let res = await $api.twoReport.get('bankAccountImportLog');
        this.loading = false;
        if (res.status === 1) {
          this.tableData = res.data;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      remove(row) {
        this.$XModal.confirm("您确定要删除吗？").then((type) => {
          if (type === "confirm") {
            this.deleteBankAccountImport(row.id);
          }
        });
      },
      async deleteBankAccountImport(id) {
        showLoading();
        let res = await $api.twoReport.post('deleteBankAccountImport', {id: id});
        hideLoading();
        if (res.status === 1) {
          this.$Message.success('删除成功');
          this.bankAccountImportLog();
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      addLink() {
        this.linkAccountModal = true;
      },
      close() {
        this.linkAccountModal = false;
      },
      refresh() {

      }
    }
  }
</script>
<style>

</style>